/**
 * 산업별 솔루션 페이지 번역 - 한국어
 */

export default {
  hero: {
    title: '산업별 솔루션',
    subtitle: '금융, 제조, 리테일, 전문 서비스, 헬스케어, 공공 부문 등 다양한 산업에 맞춘 디지털 및 지능형 솔루션을 제공합니다',
    imageAlt: '산업별 솔루션 배경 이미지'
  },

  overview: {
    title: '제품 개요'
  },

  industries: {
    finance: {
      title: '금융 산업 솔루션',
      imageAlt: '금융 산업 솔루션',
      painPoints: {
        title: '주요 과제',
        content: '사이버 보안 위협, 엄격한 컴플라이언스 요구, 노후한 레거시 시스템, 높아지는 고객 경험 기대치'
      },
      solution: {
        title: '해결 방안',
        content: '금융 클라우드 현대화, 통합 규제 보고, 관리형 보안 서비스, 옴니채널 고객 플랫폼을 중심으로 안전하고 민첩한 디지털 금융 기반을 구축합니다'
      },
      results: {
        title: '구현 효과',
        content: '핵심 시스템 현대화와 자동화된 규제 보고를 지원하여 출시 주기를 단축하고 고객 서비스 일관성을 높입니다'
      }
    },

    ticketAi: {
      title: '스마트 티켓 및 AI 분석 플랫폼',
      imageAlt: '스마트 티켓 및 AI 분석 플랫폼',
      ticketSystem: {
        title: '스마트 티켓 시스템',
        features: [
          '티켓 자동 생성, 배정 및 우선순위 정렬',
          '멀티채널 접수(이메일, 전화, 채팅, API)',
          'SLA 관리와 실시간 모니터링 대시보드',
          '사용자 정의 워크플로우와 규칙 엔진',
          '지식 베이스 연동 및 자동 응답 제안'
        ]
      },
      aiAnalytics: {
        title: 'AI 분석 및 데이터 통합',
        features: [
          '자연어 처리 기반 티켓 내용 분석',
          '잠재 문제와 추세를 식별하는 예측 분석',
          '다중 데이터 소스 통합과 시각화 보고서',
          '맞춤 KPI 모니터링 및 이상 알림',
          '서드파티 시스템과의 개방형 API 연동'
        ]
      },
      results: {
        title: '구현 효과',
        content: '티켓 처리 효율 65% 향상, 수작업 오류 40% 감소, 고객 만족도 35% 향상, 운영 비용 28% 절감'
      }
    },

    manufacturing: {
      title: '제조 산업 솔루션',
      imageAlt: '제조 산업 솔루션',
      painPoints: {
        title: '주요 과제',
        content: '공급망 중단, 낮은 생산 효율, 설비 다운타임, 품질 편차, 데이터 사일로'
      },
      solution: {
        title: '해결 방안',
        content: '산업용 IoT, MES-ERP 통합, 공급망 대시보드, 현장 디지털 트윈을 중심으로 스마트 팩토리와 디지털 공급망 역량을 구축합니다'
      },
      results: {
        title: '구현 효과',
        content: '생산 투명성과 품질 추적성을 높이고 다운타임 위험을 낮추며 공급망 협업 효율을 강화합니다'
      }
    },

    retail: {
      title: '리테일 산업 솔루션',
      imageAlt: '리테일 산업 솔루션',
      painPoints: {
        title: '주요 과제',
        content: '다국가 다매장의 서비스 요청이 분산되고 매장 네트워크, POS, 단말 장애가 영업에 영향을 주며 현지 대응력과 매장 생애주기 프로세스가 일관되지 않습니다'
      },
      solution: {
        title: '해결 방안',
        content: 'APAC 전역 매장 IT 지원을 위해 통합 서비스 데스크, 현지 엔지니어 네트워크, 매장 IT 생애주기 관리, 표준화된 데이터 기반 운영 체계를 제공합니다'
      },
      results: {
        title: '구현 효과',
        content: '수백 개 매장의 요청을 중앙에서 관리하고 응답 속도와 서비스 통제력을 높이며 안정적이고 효율적인 매장 IT 운영 모델을 구축합니다'
      }
    },

    healthcare: {
      title: '헬스케어 산업 솔루션',
      imageAlt: '헬스케어 산업 솔루션',
      painPoints: {
        title: '주요 과제',
        content: '의료 데이터 프라이버시 보호, 기관 간 데이터 공유의 어려움, 원격 의료 시스템의 높은 안정성 요구'
      },
      solution: {
        title: '해결 방안',
        content: '개인정보 보호 규정에 부합하는 보안 중심의 의료 데이터 저장 및 교환 플랫폼을 구축합니다'
      },
      results: {
        title: '구현 효과',
        content: '데이터 교환 효율 60% 향상, 환자 정보 보안 컴플라이언스 100%, 원격 진료 시스템 안정성 99.9%'
      }
    },

    government: {
      title: '정부 및 공공 부문 솔루션',
      imageAlt: '정부 및 공공 부문 솔루션',
      painPoints: {
        title: '주요 과제',
        content: '전자정부 시스템의 높은 안정성 요구, 엄격한 데이터 보안 요구, 낮은 부서 간 협업 효율'
      },
      solution: {
        title: '해결 방안',
        content: '다부처 데이터 공유와 업무 협업을 지원하는 고신뢰 IT 인프라 및 보안 체계를 구축합니다'
      },
      results: {
        title: '구현 효과',
        content: '시스템 장애율 45% 감소, 부서 간 처리 효율 50% 향상, 데이터 보안 컴플라이언스 100%'
      }
    }
  },

  focusIndustries: {
    title: '산업별 세부 솔루션',
    subtitle: '금융, 제조, 리테일, 헬스케어, 공공 부문, 스마트 티켓과 AI 분석의 여섯 가지 핵심 시나리오를 중심으로 요구에 더 가까운 솔루션을 정리했습니다.',
    keySolutionLabel: '핵심 솔루션',
    painPointsTitle: '산업 과제',
    solutionTitle: '솔루션 구성',
    outcomeTitle: '제공 가치',
    items: [
      {
        title: '제조업',
        keySolution: '스마트 팩토리 및 디지털 공급망',
        painPoints: '공급망 중단, 낮은 생산 효율, 설비 다운타임, 품질 편차, 데이터 사일로.',
        solutions: [
          '산업용 IoT 플랫폼: 센서를 통해 설비와 생산 라인을 연결하여 실시간 데이터 수집, 예지 정비, 에너지 관리를 수행하고 비계획 정지를 줄입니다.',
          'MES 통합: 제조 실행 시스템과 ERP를 통합하여 주문부터 완제품까지의 생산 흐름을 디지털화하고 가시화하여 효율과 추적성을 높입니다.',
          '디지털 공급망 대시보드: 공급업체 관리, 재고 최적화, 물류 추적을 통합 가시화하는 데이터 플랫폼을 구축합니다.',
          '현장 디지털 트윈: 생산 라인의 가상 모델을 구축해 시뮬레이션, 공정 최적화, 시운전, 교육에 활용합니다.'
        ],
        outcome: '설비 연결, 공정 협업, 공급망 가시화를 결합하여 비계획 다운타임을 줄이고 생산 거점 간 품질 추적성을 향상합니다.'
      },
      {
        title: '금융 서비스',
        keySolution: '보안, 컴플라이언스, 디지털 고객 경험',
        painPoints: '사이버 보안 위협, 엄격한 규제 요구, 레거시 핵심 시스템, 높아지는 고객 경험 기대.',
        solutions: [
          '금융 클라우드 및 핵심 시스템 현대화: 핵심 금융 및 보험 시스템을 안전하게 금융 클라우드로 이전하여 복원력과 민첩성을 높입니다.',
          '통합 규제 보고 플랫폼: PBOC, CBIRC 등 규제기관의 보고와 컴플라이언스를 지원하는 자동화 데이터 플랫폼을 구축합니다.',
          '금융 보안 관리 서비스: 24x7 보안 모니터링, 위협 인텔리전스, 사고 대응으로 고객 데이터와 거래 흐름을 보호합니다.',
          '옴니채널 뱅킹 플랫폼: 모바일, 온라인, 지점 시스템을 통합하여 일관된 개인화 고객 경험을 제공합니다.'
        ],
        outcome: '클라우드 현대화, 규제 자동화, 관리형 보안 운영을 통해 복원력과 감사 대응력, 채널 간 서비스 품질을 향상합니다.'
      },
      {
        title: '리테일 산업',
        keySolution: '다국가 매장 IT 운영 솔루션',
        painPoints: '다국가 매장의 요청 채널이 분산되고 장비와 네트워크 장애가 영업에 영향을 주며 개점, 이전, 폐점 프로세스와 현지 대응 수준이 일관되지 않습니다.',
        solutions: [
          '통합 서비스 데스크: 모든 매장 IT 요청을 중앙에서 접수, 배정, SLA 추적, 에스컬레이션, 종료 관리합니다.',
          '현지 엔지니어 네트워크: APAC 주요 지역을 커버하며 원격 진단과 현장 지원으로 매장 네트워크, POS, 단말, 주변기기 문제에 대응합니다.',
          '매장 IT 생애주기 관리: 신규 매장 오픈, 일상 운영, 이전, 업그레이드, 폐점 회수를 표준 체크리스트로 지원합니다.',
          '표준화 및 데이터 기반 운영: 매장 자산, 서비스 이력, 장애 유형, 응답 데이터를 축적해 운영 대시보드와 지속 개선에 활용합니다.'
        ],
        outcome: '수백 개 매장을 효율적으로 관리하고 영업 영향을 줄이며 안정적이고 효율적이며 통제 가능한 매장 IT 운영 체계를 구축합니다.'
      },
      {
        title: '헬스케어 산업',
        keySolution: '안전하고 규정에 부합하는 의료 데이터 저장 및 교환',
        painPoints: '의료 데이터 개인정보 보호 요구가 높고 기관 간 데이터 공유가 어렵으며 원격 의료 시스템에는 높은 안정성이 필요합니다.',
        solutions: [
          '의료 데이터 저장 및 교환 플랫폼: 안전한 데이터 교환 채널을 구축해 기관 간 협업과 정보 공유를 지원합니다.',
          '개인정보 보호 및 권한 체계: 역할, 기관, 업무 시나리오에 기반한 접근 제어, 감사 추적, 데이터 마스킹을 설계합니다.',
          '원격 의료 안정성 보장: 네트워크, 단말, 애플리케이션, 모니터링 계층의 가용성을 높입니다.',
          '컴플라이언스 아키텍처: 의료 데이터 보호 요구에 맞는 시스템 구조와 운영 프로세스를 설계합니다.'
        ],
        outcome: '의료 데이터 교환 효율과 원격 진료 안정성을 높이고 환자 정보 보안과 컴플라이언스를 보장합니다.'
      },
      {
        title: '정부 및 공공 부문',
        keySolution: '고신뢰 IT 인프라와 보안 보호 체계',
        painPoints: '전자정부 시스템에는 높은 안정성이 필요하고 데이터 보안 요구가 엄격하며 부서 간 데이터 공유와 업무 협업 효율이 낮습니다.',
        solutions: [
          '고신뢰 인프라: 핵심 공공 시스템의 지속 운영을 위해 컴퓨팅, 네트워크, 스토리지, 재해 복구 역량을 구축합니다.',
          '데이터 보안 보호: ID 인증, 접근 제어, 보안 모니터링, 로그 감사, 사고 대응을 포괄합니다.',
          '부서 간 데이터 공유: 데이터 표준, API 규격, 공유 프로세스를 통일하여 다부처 협업을 지원합니다.',
          '운영 및 컴플라이언스 관리: 점검, 모니터링, 장애 대응, 보안 컴플라이언스의 폐쇄 루프를 구축합니다.'
        ],
        outcome: '시스템 장애율을 낮추고 부서 간 처리 효율과 데이터 보안 컴플라이언스를 높여 공공 서비스의 안정 운영을 지원합니다.'
      },
      {
        title: '스마트 티켓 및 AI 분석',
        keySolution: '자동화 서비스 관리와 지능형 운영 분석',
        painPoints: '서비스 요청 채널이 분산되고 수동 배정 효율이 낮으며 SLA 실시간 모니터링, 추세 예측, 다중 데이터 분석 역량이 부족합니다.',
        solutions: [
          '스마트 티켓 시스템: 티켓 자동 생성, 배정, 우선순위 정렬, 멀티채널 접수, SLA 관리, 사용자 정의 워크플로우를 지원합니다.',
          '지식 베이스와 자동 응답 제안: FAQ, SOP, 과거 티켓 경험을 처리 흐름에 연결합니다.',
          'AI 분석: NLP로 티켓 내용을 해석하고 예측 분석으로 잠재 문제, 추세, 이상 징후를 식별합니다.',
          '데이터 통합 및 시각화: 다중 데이터 소스, 사용자 정의 KPI, 이상 알림, 개방형 API, 외부 시스템 연동을 제공합니다.'
        ],
        outcome: '티켓 처리 효율을 높이고 수작업 오류를 줄이며 고객 만족도를 높이고 운영 비용을 절감합니다.'
      }
    ]
  },

  productMatrix: {
    title: '확장 제품 및 디지털 역량',
    subtitle: '스마트 티켓 및 AI 분석 플랫폼 외에도 고객 운영, 서비스 흐름, 내부 협업을 위한 CRM, 마케팅 자동화, 미니 프로그램, AI 지식 베이스, 오피스 지능형 에이전트를 제공합니다.',
    modulesTitle: '핵심 모듈',
    scenariosTitle: '적용 시나리오',
    noteTitle: '조합형 기획과 단계별 도입 지원',
    note: '이 역량들은 독립적으로 도입할 수도 있고 웹사이트, CRM, ERP, 티켓 시스템, 이메일 흐름, 내부 운영 프로세스와 연동할 수도 있습니다. 현재 시스템, 조직 구조, 비즈니스 흐름에 맞춰 도입 방식을 설계합니다.',
    action: '솔루션 문의하기',
    items: [
      {
        title: 'CRM 소프트웨어 개발',
        tagline: '멤버십 체계와 C-엔드 사용자 운영',
        description: '브랜드의 소비자 사용자 운영을 위한 멤버십 CRM을 맞춤 개발하며, 회원 프로필, 세분화, 포인트, 쿠폰, 혜택, 참여 터치포인트, 재구매 분석을 포괄합니다.',
        modules: [
          '회원 프로필, 태그, 세분화',
          '포인트, 쿠폰, 등급, 혜택 관리',
          '사용자 행동 분석 및 재구매 운영'
        ],
        scenarios: [
          '브랜드 멤버십 운영',
          '소비자 사용자 참여 강화',
          '캠페인 성장 및 재구매 촉진'
        ]
      },
      {
        title: 'MA 마케팅 자동화',
        tagline: '자동화된 참여와 전환 성장',
        description: '웹사이트 양식, CRM, 이메일, SMS, 기업용 메신저를 연결하여 리드 점수화, 자동 세분화, 고객 여정, 전환 귀속 분석의 폐쇄 루프를 만듭니다.',
        modules: [
          '리드 스코어링 및 태그 체계',
          '자동화 여정 및 트리거 메시지',
          '캠페인 귀속 및 전환 분석'
        ],
        scenarios: [
          '웹사이트 리드 육성',
          '전시회 및 이벤트 후속 대응',
          '회원 재활성화 및 재구매 운영'
        ]
      },
      {
        title: '미니 프로그램 개발',
        tagline: '가벼운 서비스 진입점',
        description: '고객 서비스, 멤버십 운영, 예약 접수, 티켓 조회, 업무 처리를 위한 미니 프로그램을 맞춤 개발하고 백엔드와 통합합니다.',
        modules: [
          '로그인, 멤버십, 조직 권한',
          '양식, 티켓 흐름, 메시지 센터',
          'CRM, ERP, 결제, API 연동'
        ],
        scenarios: [
          '고객 서비스 진입 채널',
          '내부 수리 요청 및 승인',
          '회원 서비스와 예약 처리'
        ]
      },
      {
        title: 'AI 지식 베이스',
        tagline: '지식 축적과 지능형 Q&A',
        description: 'FAQ, SOP, 티켓 처리 경험, 제품 자료, 내부 문서를 권한 제어와 다국어 검색, 대화형 지식 서비스로 통합합니다.',
        modules: [
          '문서 수집 및 버전 관리',
          '시맨틱 검색과 답변 생성',
          '권한 제어와 피드백 루프'
        ],
        scenarios: [
          '고객 지원 지식 보조',
          '내부 운영 지식 관리',
          '지역별 교육과 베스트 프랙티스 재사용'
        ]
      },
      {
        title: '오피스 지능형 에이전트',
        tagline: '사무 워크플로우 자동화',
        description: '이메일, 승인, 회의록, 작업 분배, 일간/주간 보고, 지식 조회를 위한 에이전트 역량을 구축하고 기업 시스템 및 워크플로우와 연결합니다.',
        modules: [
          '이메일, 메신저, 캘린더, 문서 연결',
          '워크플로우 트리거와 업무 오케스트레이션',
          '데이터 반영, 감사 로그, 권한 제어'
        ],
        scenarios: [
          '영업 후속 조치 자동화',
          '서비스 운영 협업',
          '관리 회의 및 지식 Q&A'
        ]
      }
    ]
  },

  coreFeatures: {
    title: '핵심 기능',

    ticketManagement: {
      title: '지능형 티켓 관리',
      description: '생성부터 해결까지 티켓의 전 수명주기를 추적하고 맞춤 필드와 상태를 지원합니다. 자동 분류와 우선순위 정렬로 티켓 처리 효율을 최대 65%까지 높일 수 있습니다.',
      benefits: [
        '자동 라우팅',
        'SLA 타이머',
        '일괄 작업',
        '팀 협업'
      ]
    },

    dataAnalytics: {
      title: '실시간 데이터 분석',
      description: '핵심 성과 지표를 실시간으로 모니터링하는 직관적 대시보드로 빠른 의사결정을 지원합니다. 다차원 데이터 표현을 통해 이상 징후 식별 속도를 40% 높였습니다.',
      benefits: [
        '맞춤형 보고서',
        '추세 분석',
        '부서 간 비교',
        '내보내기 기능'
      ]
    },

    aiAssistant: {
      title: 'AI 스마트 어시스턴트',
      description: '머신러닝 기반 지능형 분석 엔진이 문제 패턴을 자동 식별하고 해결 방안을 제안합니다. 자연어 처리 기술을 통해 티켓 자동 분류 정확도가 92%에 달합니다.',
      benefits: [
        '자동 분류',
        '우선순위 예측',
        '해결안 추천',
        '감성 분석'
      ]
    },

    dataIntegration: {
      title: '데이터 통합 역량',
      description: '기존 엔터프라이즈 시스템과 원활하게 연결해 양방향 데이터 흐름을 실현하고 정보 사일로를 해소합니다. 200개 이상의 API 연동을 지원하며 데이터 동기화 지연은 100ms 미만입니다.',
      benefits: [
        'API 인터페이스',
        '서드파티 연동',
        '데이터 동기화',
        '보안 인증'
      ]
    }
  },

  cta: {
    title: '귀사 산업에 맞는 지능형 솔루션을 제안합니다',
    description: '당사의 스마트 티켓 시스템과 AI 분석 플랫폼은 금융, 제조, 헬스케어 등 다양한 산업에서 성공적으로 적용되어 운영 효율 향상, 비용 절감, 데이터 기반 의사결정을 지원해 왔습니다. 전용 상담을 요청해 주세요.',
    button: '산업별 솔루션 문의'
  }
}
